import { Component, OnInit } from '@angular/core';
import { CmsService, ContentSlotData } from '@spartacus/core';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { Observable } from 'rxjs';

import { KnBrCommonService } from '../../../services/kn-br-common.service';
import { KnBrDraftOrder } from './../../../models/kn-br-draft-order.model';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'knbr-kn-br-draft-order-delete-items',
    templateUrl: './kn-br-draft-order-delete-items.component.html',
    styleUrls: ['./kn-br-draft-order-delete-items.component.scss'],
    imports: [AsyncPipe]
})
export class KnBrDraftOrderDeleteItemsComponent implements OnInit {
  editable = true;
  components: ContentSlotData;
  isProductSelected$: Observable<number[]> = this.knBrCommonService.loadCartEntry();

  constructor(
    private activeCartService: ActiveCartService,
    private knBrCommonService: KnBrCommonService,
    private cmsService: CmsService
  ) {}

  ngOnInit(): void {}

  delete() {
    this.knBrCommonService
      .loadCartEntry()
      .subscribe((entries) => {
        this.activeCartService.removeEntry({ entryNumber: entries.toString() as any });
      })
      .unsubscribe();
  }

  isDisabled() {
    let editable = true;
    this.cmsService
      .getContentSlot('KnBrDraftOrderHeaderSlot')
      .subscribe((value) => (this.components = value))
      .unsubscribe();
    this.activeCartService
      .getActive()
      .subscribe((value: KnBrDraftOrder) => (editable = value.editable))
      .unsubscribe();
    if (
      (this.components &&
        this.components.components &&
        this.components.components.length &&
        this.components.components[0].flexType === 'KnBrDraftOrderHeaderComponentReadOnly') ||
      !editable
    ) {
      return true;
    }
    return false;
  }
}
